import { render } from "./temporalily-closed-badge.vue?vue&type=template&id=64390026"
import script from "./temporalily-closed-badge.vue?vue&type=script&lang=js"
export * from "./temporalily-closed-badge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__